import React, { useState } from "react";
import HeroAdmin from "./components/HomeHero";
import AboutAdmin from "./components/AboutAdmin";
import VivaakOfferingAdmin from "./components/VivaakOfferingAdmin";
import AmenitiesServicesAdmin from "./components/AmenitiesServicesAdmin";
import GalleryForm from "./components/GalleryForm";
import AdminCarouselManager from "./components/AdminCarouselManager"; // Import the AdminCarouselManager component
import AdminVillaGallery from "./components/AdminVillaGallery";
import AdminLocalAttractions from "./components/AdminLocalAttractions";
import AdminSpecialOffers from "./components/AdminSpecialOffers";
import AdminTestimonials from "./components/AdminTestimonials";
import AdminFaqs from "./components/AdminFaqs";
import AdminWeMakeItSpecial from "./components/AdminWeMakeItSpecial";
import { useData } from "../../context/DataContext";

const PROPERTY_OPTIONS = [
  { id: "main",   label: "Main Homepage" },
  { id: "vivaak", label: "The Vivaak, Dharampur (6BR)" },
  { id: "barog",  label: "Twilight, Barog (4BR)" },
];

const HomeAdmin = () => {
  const { activeHomeProperty, setActiveHomeProperty } = useData();

  // Possible tabs
  const TABS = {
    hero: "HeroAdmin",
    about: "AboutAdmin",
    vivaakOffering: "vivaakOffering",
    ammentiesServices: "ammentiesServices",
    gallery: "GalleryAdmin",
    carousel: "CarouselAdmin", // Add a new tab for the carousel
    villaGallery: "VillaGalleryAdmin", // Add a new tab for the villa gallery
    localAttractions: "LocalAttractionsAdmin", // Add a new tab for local attractions
    specialOffers: "SpecialOffersAdmin", // Add a new tab for special offers
    testimonials: "TestimonialsAdmin", // Add a new tab for testimonials
    faqs: "FaqsAdmin", // Add a new tab for FAQs
    weMakeItSpecial: "WeMakeItSpecialAdmin", // Add a new tab for "We Make It Special"
  };

  // By default show hero admin
  const [activeTab, setActiveTab] = useState(TABS.hero);

  // Function to switch tab
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="p-4 space-y-8">
      {/* Property Selector */}
      <div className="flex flex-wrap gap-2 items-center">
        {PROPERTY_OPTIONS.map((opt) => {
          const active = activeHomeProperty === opt.id;
          return (
            <button
              key={opt.id}
              type="button"
              onClick={() => setActiveHomeProperty(opt.id)}
              className={`px-4 py-2 rounded-lg text-sm font-semibold border transition ${
                active
                  ? "bg-[#14251F] text-[#FFD1A0] border-[#14251F] shadow"
                  : "bg-white text-[#14251F] border-gray-200 hover:bg-gray-50"
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>

      {/* Top Buttons */}
      <div className="flex flex-wrap gap-4 mb-6">
        <button
          onClick={() => handleTabChange(TABS.hero)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.hero
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          HomeHero
        </button>
        {activeHomeProperty !== "main" && <>
          <button
          onClick={() => handleTabChange(TABS.about)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.about
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          AboutAdmin
        </button>
        <button
          onClick={() => handleTabChange(TABS.vivaakOffering)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.vivaakOffering
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          VivaakOffering
        </button>
        <button
          onClick={() => handleTabChange(TABS.ammentiesServices)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.ammentiesServices
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Amenities Services
        </button>
        <button
          onClick={() => handleTabChange(TABS.gallery)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.gallery
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Visual Offering Gallery
        </button>
        <button
          onClick={() => handleTabChange(TABS.carousel)} // Add button for carousel
          className={`px-6 py-2 rounded ${
            activeTab === TABS.carousel
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Carousel
        </button>
        <button
          onClick={() => handleTabChange(TABS.villaGallery)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.villaGallery
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Villa Gallery
        </button>

        <button
          onClick={() => handleTabChange(TABS.localAttractions)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.localAttractions
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Local Attractions
        </button>

        <button
          onClick={() => handleTabChange(TABS.testimonials)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.testimonials
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Testimonials
        </button>

        <button
          onClick={() => handleTabChange(TABS.faqs)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.faqs
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          FAQs
        </button>
        <button
          onClick={() => handleTabChange(TABS.weMakeItSpecial)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.weMakeItSpecial
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          We Make It Special
        </button>
        </>}
      </div>

      {/* Render selected component */}
      <div className="bg-gray-50 p-4 rounded shadow">
        {activeTab === TABS.hero && <HeroAdmin />}
        {activeTab === TABS.about && <AboutAdmin />}
        {activeTab === TABS.vivaakOffering && <VivaakOfferingAdmin />}
        {activeTab === TABS.ammentiesServices && <AmenitiesServicesAdmin />}
        {activeTab === TABS.gallery && <GalleryForm />}
        {activeTab === TABS.carousel && <AdminCarouselManager />}{" "}
        {activeTab === TABS.villaGallery && <AdminVillaGallery />}
        {activeTab === TABS.localAttractions && <AdminLocalAttractions />}
        {activeTab === TABS.specialOffers && <AdminSpecialOffers />}
        {activeTab === TABS.testimonials && <AdminTestimonials />}
        {activeTab === TABS.faqs && <AdminFaqs />}
        {activeTab === TABS.weMakeItSpecial && <AdminWeMakeItSpecial />}
        {/* Render AdminCarouselManager */}
      </div>
    </div>
  );
};

export default HomeAdmin;